/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractV1Dto } from './ContractV1Dto';
import type { CustomerV1Dto } from './CustomerV1Dto';
import type { PartnerV1Dto } from './PartnerV1Dto';
export type ContractingPartyToContractV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The role of the contracting-party in the contract.
   */
  role: ContractingPartyToContractV1Dto.role;
  /**
   * The date from which the relation is valid.
   */
  validFrom?: string | null;
  /**
   * The date until which the relation is valid.
   */
  validTo?: string | null;
  /**
   * The unique identifier of the area linked to the contracting party relation.
   */
  areaId?: string;
  /**
   * The contract linked to this relation.
   */
  contract: ContractV1Dto;
  /**
   * The customer linked to this relation.
   */
  customer?: CustomerV1Dto | null;
  /**
   * The partner linked to this relation.
   */
  partner?: PartnerV1Dto | null;
  /**
   * The caretaker linked to this relation.
   */
  caretaker?: PartnerV1Dto | null;
};
export namespace ContractingPartyToContractV1Dto {
  /**
   * The role of the contracting-party in the contract.
   */
  export enum role {
    PROPERTY_OWNER = 'Property Owner',
    PROPERTY_LANDLORD = 'Property Landlord',
    PROPERTY_TENANT = 'Property Tenant',
    PROPERTY_MANAGER = 'Property Manager',
    CENTER_MANAGEMENT = 'Center Management',
    ADVERTISING_ASSOCIATION = 'Advertising Association',
    UTILITY_MANAGER = 'Utility Manager',
    CREDITOR_PAYEE_ = 'Creditor (Payee)',
  }
}
